import graphql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteTags: { clientMutationId: never }
}

const mutateHandler = handleFetchResult<IPayload, never>({
  handler: (data) => data.deleteTags.clientMutationId,
  name: 'Tags',
})

export default function remove(id: string) {
  return client.gql.mutate({ mutation, variables: { input: { ids: [id] } } }).then(mutateHandler)
}

const mutation = graphql`
  mutation deleteTags($input: DeleteTagsMutationInput!) {
    deleteTags(input: $input) {
      clientMutationId
    }
  }
`
